import PropertyImageGallery from "./PropertyImageGallery";
import PropertySummaryCard from "./PropertySummaryCard";

const PropertyDetailHero = ({ property, onShare }) => (
  <section className="property-detail-hero" aria-label="Property overview">
    <div className="property-detail-hero__gallery">
      <PropertyImageGallery
        property={property}
        gallery={property.gallery}
        primaryImage={property.primaryImage}
      />
    </div>
    <div className="property-detail-hero__summary">
      <PropertySummaryCard property={property} onShare={onShare} />
    </div>
  </section>
);

export default PropertyDetailHero;
